// extracted by mini-css-extract-plugin
export var modalFooter = "_mb-0";